import { Stack, Paper } from '@packages/shared';
import { actionBarPx } from '../../styles';

export type ActionsBarProps = {
  children: React.ReactNode;
};

export const ActionsBar = ({ children }: ActionsBarProps) => (
  <Paper component="div" elevation={4} sx={{ overflow: 'hidden', position: 'sticky', bottom: 0 }}>
    <Stack
      sx={{
        px: actionBarPx,
        py: 2.5,
        border: '0 solid transparent',
        borderTopWidth: '4px',
        borderTopColor: 'grey.light',
        flexDirection: ['column', 'column', 'row'],
        flexWrap: ['wrap', 'wrap', 'nowrap'],
        alignItems: 'center',
        gap: [3, 3, 2.5],
      }}
    >
      {children}
    </Stack>
  </Paper>
);
